var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 10.2069C17.9999 9.60154 17.9463 9.02682 17.8543 8.46744H9.19531V11.9234H14.1532C13.9309 13.0575 13.2796 14.0153 12.3141 14.6667V16.9655H15.2719C17.0037 15.364 17.9999 13.0038 17.9999 10.2069Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19542 19.1954C11.6782 19.1954 13.7548 18.3678 15.272 16.9655L12.3142 14.6667C11.4866 15.2184 10.4368 15.5556 9.19542 15.5556C6.79695 15.5556 4.7663 13.9387 4.03833 11.7548H0.988525V14.1226C2.4981 17.1265 5.60155 19.1954 9.19542 19.1954Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03831 11.7548C3.84674 11.2031 3.74712 10.613 3.74712 10C3.74712 9.38697 3.8544 8.79693 4.03831 8.24521V5.8774H0.988505C0.360152 7.11877 0 8.51341 0 10C0 11.4866 0.360152 12.8812 0.988505 14.1226L4.03831 11.7548Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19542 4.44445C10.5517 4.44445 11.7625 4.91188 12.7203 5.82376L15.341 3.20307C13.7548 1.71648 11.6782 0.804604 9.19542 0.804604C5.60155 0.804604 2.4981 2.87357 0.988525 5.8774L4.03833 8.24522C4.7663 6.06131 6.79695 4.44445 9.19542 4.44445Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6ef6daf04bc22422f47081ccd82e823e.svg";
export { ForwardRef as ReactComponent };